// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__-r3JG","content":"Consent_content__1Cccz","footer":"Consent_footer__2fJ4d"};